import { TALENT } from '../../data/define';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hook/useTranslation';
import Url from '../../data/url';
import IcGlasses from '../../assets/image/ic_home_glasses.svg';
import IcWordBalloon from '../../assets/image/ic_home_word_balloon.svg';

export default function MoreInfo() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start justify-start mt-[16px]">
      <div className="text-[#1C1C1C] text-[18px] py-[18px] font-[700] text-left">
        {t('home.more_info.community_title')}
      </div>
      <button
        type="button"
        onClick={() => navigate(Url.Community)}
        className="w-full mb-[16px] cursor-pointer overflow-hidden bg-[#F0FCFC] px-[24px] rounded-[16px] border border-[#EAEAEA] flex items-center justify-between py-[24px]"
      >
        <div className="flex flex-col items-start justify-between h-full">
          <div className="text-[#1C1C1C] text-[20px] text-left font-[700]">
            {t('home.more_info.onkiz_talk_title').split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i === 0 && <br />}
              </span>
            ))}
          </div>
          <div className="text-left text-[14px] font-[400]">{t('home.more_info.onkiz_talk_desc')}</div>
        </div>
        <img src={IcWordBalloon} alt="Reading Glasses" className="w-[98px] h-[72px]" />
      </button>
      <div className="text-[#1C1C1C] text-[18px] py-[18px] font-[700] text-left">
        {t('home.more_info.more_onkiz_title')}
      </div>
      <button
        type="button"
        onClick={() => navigate(Url.HomeMultiIntelligenceIntro)}
        className="w-full mb-[16px] overflow-hidden bg-[#FEF8E3] rounded-[16px] border border-[#EAEAEA] flex flex-col items-start justify-between py-[24px]"
      >
        <div className="flex flex-col items-start justify-start h-full px-[24px] mb-[20px]">
          <div className="text-[#1C1C1C] text-[20px] font-[700]">
            {t('home.more_info.multi_intelligence_title')}
          </div>
          <div className="text-left text-[14px] font-[400]">
            {t('home.more_info.multi_intelligence_desc')}
          </div>
        </div>
        <div className="w-full overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
          <div className="px-[20px] inline-flex items-center justify-start gap-[12px]">
            {Object.values(TALENT).map((talent) => (
              <div key={talent.key} className="flex flex-col items-center justify-center">
                <div className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center">
                  <img src={talent.icon} alt={talent.key} className="w-[40px] h-[36px]" />
                </div>
                <div className="font-[400] text-[14px] mt-[8px]">{t(`talent.${talent.key}`)}</div>
              </div>
            ))}
          </div>
        </div>
      </button>
      <button
        type="button"
        onClick={() => navigate(Url.HomeOnkidsAIIntro)}
        className="w-full mb-[16px] cursor-pointer overflow-hidden bg-[#EEE4FF] px-[24px] rounded-[16px] border border-[#EAEAEA] flex items-center justify-between py-[24px]"
      >
        <div className="flex flex-col items-start justify-between h-full">
          <div className="text-[#1C1C1C] text-[20px] text-left font-[700]">
            {t('home.more_info.ai_tech_title').split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i === 0 && <br />}
              </span>
            ))}
          </div>
          <div className="text-left text-[14px] font-[400]">{t('home.more_info.ai_tech_desc')}</div>
        </div>
        <img src={IcGlasses} alt="Reading Glasses" className="w-[98px] h-[72px]" />
      </button>
    </div>
  );
}
